module.exports = __webpack_public_path__ + "img/i-payments-admin.811b83ce.svg";